import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import { auth, db } from "./firebase";
import { doc, getDoc } from "firebase/firestore";

import Login from "./components/Login";
import DashboardLayout from "./components/DashboardLayout";
import DashboardOverview from "./components/DashboardOverview";
import PostsList from "./components/PostsList";
import CreatePost from "./components/CreatePost";
import Categories from "./components/Categories";
import UsersList from "./components/UsersList";
import SendNotification from "./components/SendNotification";
import DriversStandings from "./components/DriversStandings";
import ConstructorsStandings from "./components/ConstructorsStandings";
import RaceCalendar from "./components/RaceCalendar";
import RacesPage from "./components/engine/RacesPage";



function App() {
  const [isAdmin, setIsAdmin] = useState(null);
  const [adminUser, setAdminUser] = useState(null);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        setIsAdmin(false);
        return;
      }

      const snap = await getDoc(doc(db, "users", user.uid));
      if (snap.exists() && snap.data().role === "admin") {
        setIsAdmin(true);
        setAdminUser(user);
      } else {
        setIsAdmin(false);
      }
    });

    return () => unsub();
  }, []);

  if (isAdmin === null) {
    return (
      <div className="login-page">
        <div className="login-card">Checking session...</div>
      </div>
    );
  }

  return (
    <BrowserRouter>
      <Routes>
        {!isAdmin ? (
          <Route path="*" element={<Login setAdmin={setIsAdmin} />} />
        ) : (
          <Route path="/" element={<DashboardLayout setAdmin={setIsAdmin} />}>
            <Route index element={<Navigate to="/dashboard" />} />
            <Route path="dashboard" element={<DashboardOverview />} />
            <Route path="/races" element={<RacesPage />} />
            <Route path="posts" element={<PostsList />} />
            <Route path="create" element={<CreatePost admin={adminUser} />} />
            <Route path="categories" element={<Categories admin={adminUser} />} />
            <Route path="users" element={<UsersList />} />
            <Route path="notifications" element={<SendNotification />} />
            <Route path="/standings/drivers" element={<DriversStandings admin={adminUser} />} />
            <Route path="/standings/constructors" element={<ConstructorsStandings admin={adminUser} />} />
            <Route path="/calendar" element={<RaceCalendar admin={adminUser} />} />

          </Route>
        )}
      </Routes>
    </BrowserRouter>
  );
}

export default App;
